// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"cda612ba","885":"5edec474"}[chunkId] + ".chunk.js";
};